import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StorefrontIcon from '@material-ui/icons/Storefront';
import { NavLink } from 'react-router-dom';
import { ReactComponent as Logo } from 'assets/images/kealogo-text-bg.svg';
import { getInitUrlByShop, getShopIdFromLocation } from '../../util/appUtils';
import IntlMessages from 'util/IntlMessages';

const UserInfo = () => {
  const { auth: { authorization } } = useSelector((state) => state);

  const [anchorE1, setAnchorE1] = useState(null);
  const [open, setOpen] = useState(false);
  const shops = authorization?.shopList || [];
  const currentShop = getShopIdFromLocation() || 'Select a store';
  const currentShopDetails = authorization?.shopMap?.[currentShop]
    || shops.find(shop => shop.shopId === currentShop);
  const currentShopLabel = currentShopDetails?.shopName || currentShop;
  const canSwitchShop = shops.length > 1;

  const handleClick = (event) => {
    setOpen(true);
    setAnchorE1(event.currentTarget);
  };

  const handleRequestClose = () => {
    setOpen(false);
  };

  return (
    <div className={`user-profile kealabs-logo-container ${canSwitchShop ? 'has-shop-switcher' : 'single-shop'}`}>
      <Logo className="kealabs-logo" />
      {canSwitchShop && (
        <>
          <div className="user-detail">
            <button
              type="button"
              className="user-name user-shop-button"
              onClick={handleClick}
              aria-haspopup="menu"
              aria-expanded={open}
              aria-controls={open ? 'shop-switcher-menu' : undefined}
            >
              <span className="user-shop-icon" aria-hidden="true"><StorefrontIcon /></span>
              <span className="user-shop-copy">
                <span className="user-shop-caption"><IntlMessages id="ui.userInfo.store" /></span>
                <span className="user-shop-name">{currentShopLabel}</span>
              </span>
              <ExpandMoreIcon className="user-shop-chevron" aria-hidden="true" />
            </button>
          </div>
          <Menu
            className="user-info shop-switcher-menu"
            id="shop-switcher-menu"
            anchorEl={anchorE1}
            open={open}
            onClose={handleRequestClose}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            PaperProps={{ className: 'shop-switcher-paper' }}
          >
            <div className="shop-switcher-heading"><IntlMessages id="ui.userInfo.switchStore" /></div>
            {shops.map(shop => {
              const selected = shop.shopId === currentShop;
              return (
                <MenuItem
                  key={shop.shopId}
                  component={NavLink}
                  to={getInitUrlByShop(shop)}
                  onClick={() => setOpen(false)}
                  selected={selected}
                  className="shop-switcher-item"
                >
                  <ListItemIcon className="shop-switcher-item-icon">
                    <StorefrontIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={shop.shopName || shop.shopId}
                    secondary={shop.shopName ? shop.shopId : null}
                  />
                  {selected && <CheckIcon className="shop-switcher-check" fontSize="small" />}
                </MenuItem>
              );
            })}
          </Menu>
        </>
      )}
    </div>
  );
};

export default UserInfo;
